import React from 'react';

import { Container } from 'ui/components/styled';
import { Badge } from 'ui/components/shared/Badge';

export const Navbar = () => {
  return (
    <Container flexDirection="row" justifyContent="flex-end" height="auto" pt="m" px="m">
      <Badge />
    </Container>
  );
};
